import { isString } from "../utils/schemaUtils";
import { type GitHubIssue, isGitHubIssue } from "./githubIssuesSchema";

// The detail view flattens the issue fields alongside its body rather than
// nesting them, so the payload root is itself a GitHubIssue.
export interface GitHubIssueDetail extends GitHubIssue {
  type: "github_issue";
  body?: string;
}

export const parseGitHubIssuePayload = (v: unknown): GitHubIssueDetail | null => {
  if (!v || typeof v !== "object") return null;
  const r = v as Record<string, unknown>;
  if (r.type !== "github_issue") return null;
  if (!isGitHubIssue(r)) return null;
  if (r.body !== undefined && !isString(r.body)) return null;
  const issue: GitHubIssue = r;
  return {
    ...issue,
    type: "github_issue",
    body: r.body,
  };
};
